"use client";

import { queryOptions } from "@tanstack/react-query";

export const hitsOptions = (queryParams: URLSearchParams) => {
  const dateRange = queryParams.getAll("date-range");
  return queryOptions({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      "hits",
      {
        term: queryParams.get("term"),
        filterParams: queryParams.get("filter-params"),
        dateRangeStart: dateRange[0],
        dateRangeEnd: dateRange[1],
      },
    ],
    queryFn: async () => {
      const data: number = await (
        await fetch(`/api/hits?${queryParams}`)
      ).json();

      if (typeof data !== "number") {
        return 0; // for catching [object Object] until we know what's going on
      }

      return data;
    }
  });
};
